import React from 'react';
import { useI18n } from '../../utils/i18n';
import { useFeature } from '../../utils/featuresCache';
import { useBenutzerEinstellungen } from '../../services/benutzerEinstellungen';
import { assistentPosition } from '../assistent/position';
import useSofortSpeichern from './useSofortSpeichern';
import './einstellungen.css';

// #512: Abschnitt „KayCee-Assistent“ im Einstellungs-Dialog: Lage des
// schwebenden Knopfs (`assistent.position`, rechts oder links). Ohne
// KI-Suche gibt es den Knopf nicht, dann steht hier nur ein Hinweis.
export default function AssistentWahl() {
  const { t } = useI18n();
  const einstellungen = useBenutzerEinstellungen();
  const kiAn = useFeature('searchAi');
  const { speichert, speichere } = useSofortSpeichern();

  if (!kiAn) {
    return <p className="einst-text">{t('einstellungen.assistentAus', 'Die KI-Suche ist auf dieser Installation abgeschaltet, den Assistenten gibt es deshalb nicht.')}</p>;
  }
  return (
    <select
      id="einst-assistent-position"
      className="einst-auswahl"
      aria-label={t('einstellungen.assistentPosition', 'Lage des Assistenten-Knopfs')}
      value={assistentPosition(einstellungen)}
      disabled={!einstellungen || speichert}
      onChange={(e) => speichere({ assistent: { position: e.target.value } })}
    >
      <option value="rechts">{t('einstellungen.assistentRechts', 'Unten rechts')}</option>
      <option value="links">{t('einstellungen.assistentLinks', 'Unten links')}</option>
    </select>
  );
}
